/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Minimum_Feature_2Inputs */

const et_plan_minimum_feature_2 = /** @type {(inputs: Plan_Minimum_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uuendused iga 2 nädala tagant`)
};

const en_plan_minimum_feature_2 = /** @type {(inputs: Plan_Minimum_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updates every 2 weeks`)
};

/**
* | output |
* | --- |
* | "Updates every 2 weeks" |
*
* @param {Plan_Minimum_Feature_2Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_minimum_feature_2 = /** @type {((inputs?: Plan_Minimum_Feature_2Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Minimum_Feature_2Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_minimum_feature_2(inputs)
	return en_plan_minimum_feature_2(inputs)
});